import React from 'react';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

export const LinearLoader = () => (
  <div className="mt-2">
    <Spinner size="sm" />
  </div>
);

export const ResultMetric: React.FC<{
  label: string;
  value: number;
  valueClassName?: string;
}> = ({ label, value, valueClassName }) => (
  <div className="flex-1 rounded-md bg-muted p-2 text-center">
    <p className={cn('text-lg font-bold', valueClassName)}>
      {value}
    </p>
    <p className="text-xs text-muted-foreground">
      {label}
    </p>
  </div>
);
